// /src/store/booleanMap/actions.ts

import {
  UPDATE_BOOLEAN_MAP,
  BooleanMapActionTypes
} from './types';

import { Dispatch } from 'redux';

export const updateBooleanMap = (key: string, value: boolean) => (dispatch: Dispatch<BooleanMapActionTypes>) => {
  dispatch({
    type: UPDATE_BOOLEAN_MAP,
    payload: { key, value },
  });
};
